












































    import { Component, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	import ComponentListBase from "./ComponentListBase";

	@Component
	export default class ComponentList extends ComponentListBase {



		created() {
			super.initializeRights(undefined, 'COR_Component_Delete', 'COR_Component_Read', 'COR_Component_Update');			
			super.setDetailName('ComponentDetail');
            this.right_Provisioning = RightHelper.currentUserHasRight('COR_Component_Provisioning');
            this.setDeleteMessage(this.$t('component.messageQuestionMain').toString(), this.$t('component.messageQuestionMain2').toString(), this.$t('component.messageQuestionMain3').toString());

            super.created();
		};	

		showAllertToDeleteClick(itemsSelected: any) {
			//this.showAllertToDeleteClickBase(itemsSelected);
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {

                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }
		}

		showAlertToAddClick(itemsSelected: any) {
			this.showAlertToAddClickBase(itemsSelected);
		}

		moreActionAddAllow(): boolean {
			return this.moreActionAddAllowBase();
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
        detailClick(elementId: any) { super.detailClickBase(elementId); };
		deleteClick(elementId: any) { super.deleteClick(elementId);	}
	};
